export default __webpack_public_path__ + "assets/night.svg?3fad4310d7de575f869e633f7680feb0";